import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook } from "lucide-react";
import Logo from "./Logo";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const SOCIAL_ICONS = { facebook: Facebook, instagram: Instagram, linkedin: Linkedin };

export default function Footer() {
  const { t, lang } = useI18n();
  const [social, setSocial] = useState([]);
  useEffect(() => {
    api.get("/settings").then((r) => {
      const sm = r.data?.social_media || {};
      const list = ["facebook", "instagram", "linkedin"]
        .map((k) => ({ key: k, Icon: SOCIAL_ICONS[k], enabled: (sm[k] || {}).enabled, url: ((sm[k] || {}).url || "").trim() }))
        .filter((x) => x.enabled && /^https:\/\//i.test(x.url));
      setSocial(list);
    }).catch(() => {});
  }, []);
  const col = (title, links) => (
    <div>
      <h4 className="font-display font-semibold mb-4 text-sm uppercase tracking-wide text-muted-foreground">{title}</h4>
      <ul className="space-y-2.5">
        {links.map(([to, label]) => (
          <li key={to}><Link to={to} className="link-muted text-sm" data-testid={`footer-${to.slice(1) || "home"}`}>{label}</Link></li>
        ))}
      </ul>
    </div>
  );
  return (
    <footer className="border-t border-border mt-24 bg-card">
      <div className="container-x py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <Logo />
          <Link to="/withdraw" className="btn-primary mt-5 inline-flex !py-2 !px-3 text-sm" data-testid="footer-withdraw">{lang === "de" ? "Vertrag widerrufen" : "Withdraw from contract"}</Link>
          <p className="mt-4 text-sm text-muted-foreground max-w-xs">{t("footer.tagline")}</p>
          {social.length > 0 && (
            <div className="flex gap-3 mt-5" data-testid="footer-social">
              {social.map(({ key, Icon, url }) => (
                <a key={key} href={url} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${key}`}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-border hover:border-primary hover:text-primary transition-colors" aria-label={key}>
                  <Icon size={16} />
                </a>
              ))}
            </div>
          )}
        </div>
        {col(t("nav.services"), [
          ["/services", t("nav.services")], ["/web-development", t("nav.web")],
          ["/mobile-development", t("nav.mobile")], ["/business-software", t("nav.software")],
          ["/packages", t("nav.packages")],
        ])}
        {col(t("footer.company"), [
          ["/about", t("nav.about")], ["/portfolio", t("nav.portfolio")],
          ["/how-it-works", t("nav.process")], ["/blog", t("nav.blog")], ["/contact", t("nav.contact")],
        ])}
        {col(t("footer.legal"), [
          ["/legal/imprint", t("legal.imprint")], ["/legal/privacy", t("legal.privacy")],
          ["/legal/terms", t("legal.terms")], ["/legal/withdrawal", t("legal.withdrawal")],
          ["/faq", t("nav.faq")],
        ])}
      </div>
      <div className="border-t border-border">
        <div className="container-x py-5 text-sm text-muted-foreground flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} JonuzovicDesign. {t("footer.rights")}</span>
          <span>Made with precision in Germany 🇩🇪</span>
        </div>
      </div>
    </footer>
  );
}

